export default __webpack_public_path__ + "static/media/facebook.cb92e64e.svg";